import {
  ApplicationConfig,
  ErrorHandler,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { authReducer } from './store/auth/auth.reducer';
import { StartupErrorHandler } from './core/startup-error-handler';
import { AuthEffects } from './store/auth/auth.effects';
import { crmReducer } from './store/crm/crm.reducer';
import { CrmEffects } from './store/crm/crm.effects';
import { CsrfInterceptor } from './shared/interceptors/csrf.interceptor';
import { JwtInterceptor } from './shared/interceptors/jwt.interceptor';
import { TimeoutInterceptor } from './shared/interceptors/timeout.interceptor';
import { assistantReducer } from './assistant/state/assistant.reducer';
import { AssistantEffects } from './assistant/state/assistant.effects';
import { billingReducer } from './store/billing/billing.reducer';
import { BillingEffects } from './store/billing/billing.effects';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    provideStore({
      auth: authReducer,
      crm: crmReducer,
      assistant: assistantReducer,
      billing: billingReducer,
    }),
    provideEffects([AuthEffects, CrmEffects, AssistantEffects, BillingEffects]),
    ...(!environment.production
      ? [provideStoreDevtools({ maxAge: 25, logOnly: false })]
      : []),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CsrfInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: StartupErrorHandler,
    },
  ],
};
